import { useState } from "react";
import { FeedbackForm } from "./components/FeedbackForm";
import { ConfirmationPage } from "./components/ConfirmationPage";
import { PopUpMessage } from "../../shared/components/PopUpMessage";
import axios from "axios";

const SERVER = process.env.REACT_APP_SERVER;

export const HaluFeedback = () => {
    const [page, setPage] = useState<"feedback" | "confirmation">("feedback");
    const [popUpMessage, setPopUpMessage] = useState("");
    const [popUpOpen, setPopUpOpen] = useState(false);
    const [submitted, setSubmitted] = useState(false);

    const [formData, setFormData] = useState({
        anonymous: false,
        name: "",
        email: "",
        overallExperience: "",
        presentation: "",
        games: "",
        newFriends: "",
        food: "",
        likedMost: "",
        likedMostOther: "",
        improvement: "",
    });

    const handleFieldChange = (field: string, value: any) => {
        setFormData(prev => ({ ...prev, [field]: value }));
    };

    const handleFailure = () => {
        setPopUpMessage("Service unavailable, please try again in a minute.");
        setPopUpOpen(true);
    };

    const handleSubmit = () => {
        // Validate required fields
        if (!formData.anonymous) {
            if (!formData.name || !formData.email) {
                setPopUpMessage("Please fill out name and email or choose Anonymous.");
                setPopUpOpen(true);
                return;
            }
        }
        if (!formData.overallExperience || !formData.presentation || !formData.games || !formData.newFriends || !formData.food || !formData.likedMost || !formData.improvement) {
            setPopUpMessage("Please answer all required questions.");
            setPopUpOpen(true);
            return;
        }
        if (formData.likedMost === "Others" && !formData.likedMostOther) {
            setPopUpMessage("Please specify what you liked most in Others.");
            setPopUpOpen(true);
            return;
        }

        setSubmitted(true);

        const payload = {
            ...formData,
            name: formData.anonymous ? "" : formData.name,
            email: formData.anonymous ? "" : formData.email,
        };

        axios.post(`${SERVER}/halu/feedback`, payload).then((res) => {
            if (res.status === 200) {
                setPage("confirmation");
                return;
            }
            handleFailure();
            setSubmitted(false);
        }).catch(() => {
            handleFailure();
            setSubmitted(false);
        });
    };

    return (
        <div>
            <PopUpMessage
                open={popUpOpen}
                handleClose={() => setPopUpOpen(false)}
                message={popUpMessage}
            />
            <div className="flex flex-col lg:flex-row min-h-screen pt-navbar py-40 mx-[10%]">
                <div className={`lg:order-2 flex-auto w-full`}>
                    <div className={`w-[100%] ${page === 'confirmation' ? "p-[12%]" : "px-[12%]"}`}>
                        <h2>
                            {page === "confirmation"
                                ? "Thanks for your feedback!"
                                : "HALU Feedback Form"}
                        </h2>
                        {page === "feedback" &&
                            <div className="xl:max-w-[65%] py-6 flex flex-col gap-3">
                                <p>
                                    Thank you for attending HALU! We hope you had a great experience. <br />Your feedback is valuable and helps us improve future events.
                                </p>
                            </div>
                        }
                        {page === "feedback" && (
                            <>
                                <FeedbackForm state={formData} handleFieldChange={handleFieldChange} />

                                <button
                                    className="block bg-[#D07D14] w-full rounded-md text-white py-1.5 text-lg mt-7 disabled:bg-gray-400"
                                    onClick={handleSubmit}
                                    disabled={submitted}
                                >
                                    Submit Feedback
                                </button>
                            </>
                        )}
                        {page === "confirmation" && <ConfirmationPage />}
                    </div>
                </div>
            </div>
        </div>
    );
};
